import { useEffect, useState } from 'react';

import { getAccounts } from '../../../api/services/Accounts';

export const useAccounts = () => {
  const [accounts, setAccounts] = useState<Nullable<Account[]>>(null);

  useEffect(() => {
    fetchAccounts(setAccounts);
  }, []);

  return accounts;
};

async function fetchAccounts(updateAccounts: (accounts: Account[]) => void) {
  const abortController = new AbortController();

  const response = await getAccounts({ sharedBilling: true }, abortController.signal);

  if (abortController.signal.aborted) {
    return;
  }
  if (response.type === 'success') {
    const seen = new Set<string>();
    const unique = response.data.accounts.filter((a) => {
      if (!a.name || seen.has(a.name)) {
        return false;
      }
      seen.add(a.name);

      return true;
    });

    updateAccounts(unique);
  }
}
